import {AppModules} from '@shared/constants/Modules';
// Any route must be declared here and used.
// Ensures that routes as string are not used in the application
export enum PRIVATE_ROUTES {
  PRODUCT = 'product',
  ORGANIZATION = 'organization',
  DASHBOARD = 'dashboard',
  MODULE = 'module',
  APPLICATION = 'application',
  SUB_MODULE = 'submodule',
  LIST = 'list',
  UNAUTHORIZED_USER = 'unauthorized-user',
  LMS = 'lms',
  UAM='uam'
}

export enum PUBLIC_ROUTES {
  ROOT = 'bytepad',
  ROOT_DEFAULT = '/bytepad',
  LOGIN = 'login',
  SIGN_UP = 'sign-up',
  VERIFY_USER = 'verify-account/:code',
  CREATE_PASSWORD = 'create-password',
  FORGET_PASSWORD = 'forgot-password',
  TEST_BASE = 'test-base',
  RESET_PASSWORD = 'reset-password/:resetCode',
  EPIC = 'epic',
  EXTERNAL = 'external',
  UNAUTHORIZED_USER = 'unauthorized-user',
  CALL_BACK = 'callback',
  LMSLAUNCHPAGE = 'lmsLanding',
  ATHENA_EXTERNAL = 'athena-external',
  ATHENA = 'athena'
}

export interface RouteInfo {
  route: string;
  requiresAuthCheck: boolean;
  Component: any;
  id: string;
  module?: AppModules;
  hasSubRoutes?: boolean;
}
